export default "__VITE_ASSET__8qtG0TKg__"